import styles from './index.less';
// import { Arrow, EyeO } from '@react-vant/icons';
import { useEffect, useState } from 'react';
import NoData from '@/components/NoData';
import { detailWechatActivity } from '@/service/banner';
import { Helmet, useLocation } from '@umijs/max';

import { Card, Image, Typography } from 'react-vant';
import BottomSign from '../components/BottomSign';
import dayjs from 'dayjs';

interface WechatActivityDataType {
  communityId?: string;
  communityName?: string;
  content?: string;
  createBy?: string;
  createTime?: string;
  image?: string;
  publishTime?: string;
  sequenceNbr?: string;
  status?: string;
  title?: string;
  topFlag?: string;
  updateBy?: string;
  updateTime?: string;
  urlPath?: string;
  viewCount?: number;
  statusFormatName?: string;
  startTime?: string;
  endTime?: string;
  signupEndTime?: string;
  signupStartTime?: string;
  address?: string;
  activityAmount?: string;
  phone?: string;
}
const ActivityDetail = () => {
  console.log(useLocation());
  const location = useLocation();
  const data = new URLSearchParams(location.search).get('sequenceNbr');
  const formatStatus = (item: any) => {
    if (item.endFlag === '1') {
      return '已结束';
    } else {
      const startTime = dayjs(item.startTime);
      const endTime = dayjs(item.endTime);
      const currentTime = dayjs();
      const isAfterCurrentTime = currentTime.isAfter(endTime);
      const isBeforeCurrentTime = currentTime.isBefore(startTime);
      if (isBeforeCurrentTime) {
        return '未开始';
      }

      if (isAfterCurrentTime) {
        return '已结束';
      }

      if (!isAfterCurrentTime && !isBeforeCurrentTime) {
        return '进行中';
      }
    }
  };
  const [WechatActivityData, setWechatActivityData] =
    useState<WechatActivityDataType>({});
  useEffect(() => {
    detailWechatActivity({ sequenceNbr: data }).then((res) => {
      console.log(res);
      if (res && res.code === 200 && res.data) {
        const data = res.data;
        data.statusFormatName = formatStatus(res.data);
        setWechatActivityData(data);
        console.log(33, data);
      } else {
        setWechatActivityData({});
      }
    });
  }, [data]);

  const formatTime = (time: any) => {
    return time ? dayjs(time).format('YYYY-MM-DD') : '-';
  };

  return (
    <div className={styles['activityDetail']}>
      <Helmet>
        <title>社区活动详情</title>
      </Helmet>
      <div>
        {Object.entries(WechatActivityData).length ? (
          <>
            <div className={styles['newsDatailsBox']}>
              {WechatActivityData.title && (
                <div className={styles.title}>{WechatActivityData.title}</div>
              )}
              <div className={styles.timeBox}>
                <div className={styles.time}>
                  发布于{WechatActivityData.publishTime}
                </div>
                <div className={styles.time}>
                  {WechatActivityData.viewCount}浏览
                </div>
              </div>

              {WechatActivityData.image && (
                <div className={styles.cardBox}>
                  {/* <Card round>
                    <Card.Header border>活动封面</Card.Header>
                    <Card.Body> */}
                      <div className={styles['demo-image']}>
                        <Image
                          width="100%"
                          height="100"
                          fit="cover"
                          src={WechatActivityData.image}
                        />
                      </div>
                    {/* </Card.Body>
                  </Card> */}
                </div>
              )}

              <div className={styles.cardBox}>
                <Card round>
                  <Card.Header border>详细信息</Card.Header>
                  <Card.Body>
                    <div className={styles.timeBox}>
                      <div className={styles.typeLabel}>
                        开始时间：<strong>{formatTime(WechatActivityData?.startTime)}</strong>
                      </div>
                      <div className={styles.typeLabel}>
                        截止时间：<strong>{formatTime(WechatActivityData?.endTime)}</strong>
                      </div>
                    </div>
                    <div className={styles.timeBox}>
                      <div className={styles.typeLabel}>
                        报名开始时间：<strong>
                        {formatTime(WechatActivityData?.signupStartTime)}</strong>
                      </div>
                    </div>

                    <div className={styles.timeBox}>
                      <div className={styles.typeLabel}>
                        报名截止时间：
                        <strong> {formatTime(WechatActivityData?.signupEndTime)}</strong>
                      </div>
                    </div>

                    <div className={styles.addressBox}>
                      
                        <div className={styles.leftText}>活动地点: </div><Typography.Text ellipsis={3}>{WechatActivityData?.address}</Typography.Text>
                     
                    </div>

                    <div className={styles.timeBox}>
                      <div className={styles.typeLabel}>
                        活动费用: <strong>{WechatActivityData?.activityAmount}</strong>
                      </div>
                    </div>
                    <div className={styles.timeBox}>
                      <div className={styles.typeLabel}>
                        咨询电话: <strong>{WechatActivityData?.phone}</strong>
                      </div>
                    </div>
                    <div className={styles.timeBox}>
                      <div className={styles.typeLabel}>
                        活动状态: <strong>{WechatActivityData?.statusFormatName}</strong>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </div>

              {WechatActivityData.content && (
                <div className={styles.cardBox}>
                  <Card round>
                    <Card.Header border>活动内容</Card.Header>
                    <Card.Body>
                      <div
                        className={styles.content}
                        dangerouslySetInnerHTML={{
                          __html: WechatActivityData.content,
                        }}
                      ></div>
                    </Card.Body>
                  </Card>
                </div>
              )}

              {WechatActivityData.statusFormatName === '进行中' && (
                <div>
                  <BottomSign
                    sequenceNbr={WechatActivityData.sequenceNbr}
                  ></BottomSign>
                </div>
              )}
            </div>
          </>
        ) : (
          <NoData />
        )}
      </div>
    </div>
  );
};

export default ActivityDetail;
